import React from 'react'
import { Switch, Route } from 'react-router-dom'

import AgenticPromptsList from './AgenticPromptsList'
import AgenticPromptForm from './AgenticPromptForm'

const AgenticPromptsRouter = () => (
  <Switch>
    <Route exact path="/ai-prompts/new" component={AgenticPromptForm} />
    <Route exact path="/ai-prompts/:id" component={AgenticPromptForm} />
    <Route exact path="/ai-prompts" component={AgenticPromptsList} />
  </Switch>
)

export default AgenticPromptsRouter
